import React, { useEffect, useState } from "react";
import { Navbar, Container, Nav, Button, Offcanvas } from "react-bootstrap";
import { EntypoMenu } from "react-entypo-icons";
import "./Navbar.css";
import { strings } from "../../localization";
import { withRouter } from "react-router-dom";
import { getLoginValueFromStorage, getLogoUrl, ROUTE_PREFIX} from "../../config";

const CustomNavbar = ({ match, location, pageName }) => {
  const currentPath = location.pathname;
  const { restaurantName } = match.params || {};

  const [showMenu, setShowMenu] = useState(false);
  const [isLoginEnabled, setIsLoginEnabled] = useState(false);

  const currentOrders = `/${ROUTE_PREFIX}${restaurantName}/current-orders`;
  const foodSelection = `/${ROUTE_PREFIX}${restaurantName}/food-selection`;
  const foodMenu = `/${ROUTE_PREFIX}${restaurantName}/menu`;
  const pastOrders = `/${ROUTE_PREFIX}${restaurantName}/past-orders`;
  const contactUs = `/${ROUTE_PREFIX}${restaurantName}/contact-us`;
  const faq = `/${ROUTE_PREFIX}${restaurantName}/faq`;

  const highlightCurrentTab = (currentRoutName) => {
    return currentPath === currentRoutName ? "active" : "";
  };

  useEffect(() => {
    setIsLoginEnabled(getLoginValueFromStorage())
  }, [])

  return (
    <>
      <Navbar expand="md" className="custom-navbar no-overlay">
        <Container fluid className="justify-content-between">
          {/* Logo */}
          <Navbar.Brand href={`/${ROUTE_PREFIX}${restaurantName}/home`}>
            <img
              src={`data:image/png;base64,${getLogoUrl()}`}
              alt="Logo"
              height="30"
            />
          </Navbar.Brand>

          {/* Desktop Nav Links */}
          <Nav className="d-none d-md-flex">
            {
              isLoginEnabled &&
              <Nav.Link
                href={currentOrders}
                className={`nav-button nav-title-style ${highlightCurrentTab(
                  currentOrders
                )}`}
              >
                {strings.current_orders}
              </Nav.Link>
            }
            <Nav.Link
              href={isLoginEnabled ? foodSelection : foodMenu}
              className={`nav-button nav-title-style ${highlightCurrentTab(
                isLoginEnabled ? foodSelection : foodMenu
              )}`}
            >
              {strings.menu}
            </Nav.Link>
            {
              isLoginEnabled &&
              <Nav.Link
                href={pastOrders}
                className={`nav-button nav-title-style ${highlightCurrentTab(
                  pastOrders
                )}`}
              >
                {strings.past_orders}
              </Nav.Link>
            }
            <Nav.Link
              href={contactUs}
              className={`nav-button nav-title-style ${highlightCurrentTab(
                contactUs
              )}`}
            >
              {strings.contact_us}
            </Nav.Link>
            <Nav.Link
              href={faq}
              className={`nav-button nav-title-style ${highlightCurrentTab(
                faq
              )}`}
            >
              {strings.faqs}
            </Nav.Link>
          </Nav>

          {/* Mobile Menu Toggle */}
          <Button
            variant="light"
            className="d-md-none border-0"
            style={{ fontSize: 18 }}
            onClick={() => setShowMenu(true)}
          >
            <EntypoMenu size={24} />
          </Button>
        </Container>
        {pageName && (
          <h5 className="d-md-none text-center border-0 w-100 p-0 m-0 fw-bold">
            {pageName}
          </h5>
        )}
      </Navbar>

      {/* Side Drawer */}
      <Offcanvas
        show={showMenu}
        onHide={() => setShowMenu(false)}
        placement="end"
        className="custom-drawer"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title></Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column gap-0">
            {
              isLoginEnabled &&
              <Nav.Link
                href={currentOrders}
                className={`drawer-button ${highlightCurrentTab(currentOrders)}`}
              >
                {strings.current_orders}
              </Nav.Link>
            }
            <Nav.Link
              href={isLoginEnabled ? foodSelection : foodMenu}
              className={`drawer-button ${highlightCurrentTab(isLoginEnabled ? foodSelection : foodMenu)}`}
            >
              {strings.menu}
            </Nav.Link>
            {
              isLoginEnabled &&
              <Nav.Link
                href={pastOrders}
                className={`drawer-button ${highlightCurrentTab(pastOrders)}`}
              >
                {strings.past_orders}
              </Nav.Link>
            }
            <Nav.Link
              href={contactUs}
              className={`drawer-button ${highlightCurrentTab(contactUs)}`}
            >
              {strings.contact_us}
            </Nav.Link>
            <Nav.Link
              href={faq}
              className={`drawer-button ${highlightCurrentTab(faq)}`}
            >
              {strings.faqs}
            </Nav.Link>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default withRouter(CustomNavbar);
